import { render, staticRenderFns } from "./BackgroundremovalCom.vue?vue&type=template&id=b2a7d1f8&scoped=true"
import script from "./BackgroundremovalCom.vue?vue&type=script&lang=js"
export * from "./BackgroundremovalCom.vue?vue&type=script&lang=js"
import style0 from "./BackgroundremovalCom.vue?vue&type=style&index=0&id=b2a7d1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a7d1f8",
  null
  
)

export default component.exports